import CityPageTemplate from "../city-template/CityPageTemplate";
import { redmondWAConfig } from "./data";

export default function RedmondWAPage() {
  return <CityPageTemplate config={redmondWAConfig} />;
}